<template>
    <Frame>
        <PageHeader :title="$t('comm.orderImportSer')" :hasBack="false" />
        <div class="list-contain">
            <div class="head-contain">
                <div class="filter-contain" style="width: 34%;">
                    <span>{{ $t('orderImport.importDate') }}</span>
                    <el-date-picker v-model="rangeDate" 
                        type="daterange" 
                        size="small" 
                        range-separator="~"
                        :start-placeholder="$t('comm.startdate')" 
                        :end-placeholder="$t('comm.enddate')" 
                        :picker-options="PickerOptions"
                        :unlink-panels="true"
                        @change="changeTime()" >
                    </el-date-picker>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('orderImport.orderBillNoLab') }}</span>
                    <el-input v-model="BillNo" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('orderImport.customerNoLab') }}</span>
                    <el-input v-model="customerPayNo" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
                </div>
                
                <div class="filter-contain" style="width: 16%;">
                    <span>{{ $t('orderImport.importSate') }}</span>
                    <el-select size="small" v-model="importSate">
                        <el-option v-for="item in importSateList" :key="item.value" :label="item.label" :value="item.value"
                            :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </div>

                <div style="width:99%;">
                    <span style="width: 100%;display: flex; justify-content: flex-end;">
                        <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                        <el-button type="primary" @click="GetListData()">{{ $t('button.query') }}</el-button>
                    </span>
                </div>
            </div>
        </div>
        <el-tabs v-model="activeName" type="card" @tab-click="tabChange">
            <el-tab-pane :label="$t('orderImport.sucTabLable')" name="first">
                <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
                    v-loading="tableLoading">
                    <el-table-column type="index"  width="50" :label="$t('orderImport.rowNo')"></el-table-column>
                    <el-table-column :width="WidthControl('SalOrderNo',tableData)" prop="SalOrderNo" :label="$t('orderImport.orderBillNo')"></el-table-column>
                    <el-table-column width="100" prop="BillDateName" :label="$t('Order.messagedate')"></el-table-column>
                    <el-table-column :width="WidthControl('X_CustNumberOrg',tableData)" prop="X_CustNumberOrg" :label="$t('orderImport.customerNo')"></el-table-column>
                    <el-table-column width="80"  prop="X_SupId" :label="$t('Home.supplier')"></el-table-column>
                    <el-table-column width="90" prop="X_IsCustUsedName" :label="$t('orderImport.isCustUsed')"></el-table-column>
                    <el-table-column :width="WidthControl('X_BPMaterialId',tableData)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
                    <el-table-column :min-width="WidthControl('X_BPMaterialName',tableData)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
                    <el-table-column :width="WidthControl('X_lengthName',tableData)" prop="X_lengthName" :label="$t('orderImport.lengthLable')"></el-table-column>
                    <el-table-column width="80" prop="X_LUnitId" :label="$t('orderImport.lengthUnit')"></el-table-column>
                    <el-table-column :width="WidthControl('X_ColorId',tableData)" prop="X_ColorId" :label="$t('orderImport.colorLable')"></el-table-column>
                    <el-table-column :width="WidthControl('X_ColorName',tableData)" prop="X_ColorName" :label="$t('orderImport.colorName')"></el-table-column>
                    <el-table-column :width="WidthControl('SQuantityName',tableData,4)" prop="SQuantityName" :label="$t('orderImport.numLable')"></el-table-column>
                    <el-table-column :width="WidthControl('AddrId',tableData)" prop="AddrId" :label="$t('orderImport.addrLale')"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('orderImport.errorTabLable')" name="second">
                <el-table ref="multipleTable" :data="FailDataTable" :height="tableHeight" style="margin:0;width:100%"
                    v-loading="tableLoading">
                    <el-table-column type="index"  width="50" :label="$t('orderImport.rowNo')"></el-table-column>
                    <el-table-column :width="WidthControl('ImportTimeName',FailDataTable)" prop="ImportTimeName" :label="$t('orderImport.importDateTime')"></el-table-column>
                    <el-table-column width="100" prop="BillDateName" :label="$t('Order.messagedate')"></el-table-column>
                    <el-table-column :width="WidthControl('IsImportFailName',FailDataTable)" prop="IsImportFailName"  :label="$t('orderImport.importSateError')"></el-table-column>
                    <el-table-column :min-width="WidthControl('FailReason',FailDataTable)" prop="FailReason" :label="$t('orderImport.failReason')"></el-table-column>
                    <el-table-column :width="WidthControl('X_CustNumberOrg',FailDataTable)" prop="X_CustNumberOrg" :label="$t('orderImport.customerNo')"></el-table-column>
                    <el-table-column width="80" prop="X_SupId" :label="$t('Home.supplier')"></el-table-column>
                    <el-table-column width="90" prop="X_IsCustUsedName" :label="$t('orderImport.isCustUsed')"></el-table-column>
                    <el-table-column :width="WidthControl('X_BPMaterialId',FailDataTable)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
                    <el-table-column :min-width="WidthControl('X_BPMaterialName',FailDataTable)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
                    <el-table-column :width="WidthControl('X_lengthName',FailDataTable)" prop="X_lengthName" :label="$t('orderImport.lengthLable')"></el-table-column>
                    <el-table-column width="80" prop="X_LUnitId" :label="$t('orderImport.lengthUnit')"></el-table-column>
                    <el-table-column :width="WidthControl('X_ColorId',FailDataTable)" prop="X_ColorId" :label="$t('orderImport.colorLable')"></el-table-column>
                    <el-table-column :width="WidthControl('X_ColorName',FailDataTable)" prop="X_ColorName" :label="$t('orderImport.colorName')"></el-table-column>
                    <el-table-column :width="WidthControl('SQuantityName',FailDataTable,4)" prop="SQuantityName" :label="$t('orderImport.numLable')"></el-table-column>
                    <el-table-column :width="WidthControl('AddrId',FailDataTable)" prop="AddrId" :label="$t('orderImport.addrLale')"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </Frame>
</template>
<script>
import {listMixin} from '@/agency/mixin/mixin.js'
import {datePickerOptions,handleShortDate} from '@/utils/handleDate'
export default{
    name:'OrderImportSer',
    mixins:[listMixin],
    data(){
        return{
            PickerOptions:datePickerOptions(this),
            customerPayNo:'',
            tableHeight: window.innerHeight - 306,
            FailDataTable:[],
            activeName:'first',
            importSate:0,
            importSateList: [
                { value: 0, label: this.$t("orderImport.importSate0") },
                { value: 1, label: this.$t("orderImport.importSate1") },
                { value: 2, label: this.$t("orderImport.importSate2") }
            ]
        }
    },
    props:{
        GetListData:{
            type:Function,
            default:function(...arg){
                this.getListData(...arg);
            }
        }
    },
    mounted(){
        this.frameOnResize(326);
    },
    created(){
        this.rangeDate = this.getTodayDate();
        this.startDate = handleShortDate(this.rangeDate[0], "From");
        this.endDate = handleShortDate(this.rangeDate[1], "To");
        this.GetListData();
    },
    methods:{
        getTodayDate() {
            const end = new Date();
            const start = new Date();
            return [start, end];
        },
        changeTime(){
            this.getTime();
            //this.GetListData();
        },
        tabChange(tab,evernt){
            if(tab.index==0){
                this.importSate=1;
                this.activeName = 'first';
            }else{
                this.importSate = 2;
                this.activeName = 'second';
            }
            this.GetListData();
        },
        getListData(){
            if(!this.BillNo && !this.customerPayNo && !this.startDate && !this.endDate && this.importSate==0){
                this.$store.commit("TIPPOP",{popType:'warning',popMessage: this.$t("orderImport.searchTip")});
                return;
            }
            this.tableLoading = true;
            this.axiosInvoke(this.sysHandlerUrl,{
                action:'getorderimportsearch',
                billNo:this.BillNo,
                customerPayNo:this.customerPayNo,
                startDate:this.startDate,
                endDate:this.endDate,
                importSate:this.importSate
            },(res)=>{
                const data = res.data;
                this.tableLoading = false;
                this.tableData = data.SucDataTable;
                this.FailDataTable = data.FailDataTable;
                if(this.importSate == 2){
                    this.activeName = 'second';
                }else{
                    this.activeName = 'first';
                }
            },false,true);
        },
        reset(){
            this.baseReset();
            this.rangeDate = this.getTodayDate();
            this.startDate = handleShortDate(this.rangeDate[0], "From");
            this.endDate = handleShortDate(this.rangeDate[1], "To");
            this.customerPayNo = '';
            this.importSate = 0;
            this.activeName = 'first';
            this.GetListData();
        }
    }
}
</script>
<style scoped>
.list-contain{
    display: flex;
    padding: 10px 0px;
}
.head-contain{
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
.filter-contain{
    width: 23%;
    padding-right: 1%;
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 10px;
}

.filter-contain>span{
    color: black;
    font-size: 14px;
    margin: auto;
    white-space: nowrap;
}

.head-contain > div >span > .el-button{
  padding: 10px 18px;
}
.el-input {
  padding-left: 5px;
}
.el-select{
  width: 100%;
  padding-left: 5px;
}
.el-table{
  font-size: 12px;
  color: black;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}
.footer-contain{
    display: flex;
    padding-top: 6px;
    justify-content: center;
}
.pagination{
    padding-top: 4px;
}
.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}
.el-table /deep/ thead {
  font-size: 14px;
  color: black;
}
</style>
